import DoctorCard from '../../components/DoctorCard';

import { Card, DateUtils, Flex, Separator, Text, Icon } from '@amigoapp/doca-react';

const TelemedicineFinished = ({ user, date }) => (
	<Flex align="center" className="home doca-px-4" direction="col" flex={1} gap={4} justify="between">
		<Card className="doca-py-4 doca-px-8 doca-text--center doca-mt-8">
			<Flex gap={2} justify="center">
				<Icon name="video" />
				<Text align="center" as="h1" size="large">
					Seu teleatendimento foi finalizado
				</Text>
			</Flex>
			<Text className="doca-text--center doca-mt-2" size="small" variant="gray" weight="light">
				{DateUtils.format(date, { format: 'ddd, DD [de] MMMM [-] HH:mm[h]' })}
			</Text>
			<Separator className="doca-w-full" />
			<DoctorCard
				avatar={user.file?.thumb_url}
				className="doca-m-8"
				councilName={user.council_name}
				councilNumber={user.council_number}
				name={user.name}
				specialty={user.specialty}
				title={user.title}
			/>
		</Card>
		<img alt="Amigo - Logo" className="doca-w-32 doca-mb-8" src="https://cdn.amigotech.com.br/logos/amigo.svg" />
	</Flex>
);

export default TelemedicineFinished;
